import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { BusinessLoanModule } from '../business-loan/business-loan.module';
import { ButtonComponent } from '../business-loan/button/button.component';
import { NonjointInviteComponent } from './nonjoint-invite/nonjoint-invite.component';

@NgModule({
  declarations: [NonjointInviteComponent],
  imports: [CommonModule, RouterModule, BusinessLoanModule, ButtonComponent],
  exports: [NonjointInviteComponent],
})
export class NonjointInviteModule {}

